import request from '@/utils/request'
export function getpois(datajson) {
  return request({
    url: '/pois/getpois',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
